import { render, staticRenderFns } from "./User.vue?vue&type=template&id=c986feae&scoped=true&"
import script from "./User.ts?vue&type=script&lang=ts&"
export * from "./User.ts?vue&type=script&lang=ts&"
import style0 from "./User.scss?vue&type=style&index=0&id=c986feae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c986feae",
  null
  
)

export default component.exports